import { ApiProperty } from "@nestjs/swagger";

export class DeviceRequest{
    @ApiProperty()
    on: boolean;
    @ApiProperty()
    hue: number;
    @ApiProperty()
    ip: string;
    @ApiProperty()
    userName: string;
    @ApiProperty()
    deviceName: string;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    bulbId: number;
    @ApiProperty()
    status: string;
}